import React, { useState, useEffect } from 'react';
import MainLayout from '../Layout/MainLayout';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPackage } from '../redux/features/packages/packageSlice';
import PackagePlan from '../components/PackagePlan';
import Cookies from 'js-cookie';
import { getPlanOptionsByFrequency } from '../utils/planAdapter';

const JoinNow = () => {
  const [selectedPlan, setSelectedPlan] = useState({});
  const [selectedPlanID, setSelectedPlanID] = useState('');
  const packageList = useSelector((state) => state.package.packages);
  const { personalDetail } = useSelector((state) => state.signup);
  const [registrationFee, setRegistrationFee] = useState(0);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    if (packageList?.length === 0) {
      const fetchData = async () => {
        dispatch(fetchPackage());
      };
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (Array.isArray(packageList)) {
      const firstPlanWithFee = packageList.find(
        (item) => item?.pricing_summary?.one_time !== null
      );

      if (firstPlanWithFee) {
        setRegistrationFee(firstPlanWithFee?.pricing_summary?.one_time || 0);
      }
    }
  }, [packageList]);

  const handlePlan = (e, data) => {
    setSelectedPlanID(data.id);
    setSelectedPlan(data);
  };

  const handleProceed = () => {
    localStorage.setItem('selectedPlan', JSON.stringify(selectedPlan));
    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      localStorage.setItem('joinEmail', personalDetail?.email);
      navigate('/plan-checkout');
    } else {
      navigate('/joinform');
    }
  };

  return (
    <>
      <MainLayout>
        <div className="range-network-registration account-login">
          <div className="container">
            <div className="row">
              {/* <h3>THE RANGE NETWORK | REGISTRATION</h3> */}
              <h3>Enrollment</h3>
              <PackagePlan />
              <h4 className="d-none">Membership Plan</h4>
              <form onSubmit={handleProceed}>
                {packageList ? (
                  <>
                    {packageList.map((item, index) => (
                      <div className="plan-select d-none" key={index}>
                        {getPlanOptionsByFrequency(item, 'monthly', {
                          includePrepaid: false,
                          includeLifetimeFallback: true,
                        }).map((price, optionIndex) => (
                          <React.Fragment key={optionIndex}>
                            <div className="form-check" key={price.id}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="Plan"
                                id={item.id}
                                checked={selectedPlanID === item.id}
                                onChange={(e) => handlePlan(e, item)}
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor={item.id}
                              >
                                Core ({price.package_name || item.name})
                                Membership -
                                {price.display_frequency === 'Monthly'
                                  ? ' Monthly '
                                  : ' Lifetime '}
                                Retail
                              </label>
                            </div>

                            <p key={optionIndex}>
                              $ {price.price} {''} USD
                              {price.display_frequency === 'Monthly'
                                ? '/month'
                                : '/year'}
                              <br />
                              <span>(reg. fee: $ {registrationFee})</span>
                            </p>
                          </React.Fragment>
                        ))}
                      </div>
                    ))}
                  </>
                ) : (
                  <p>Loading...</p>
                )}
                {/* <div className="plan-select">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="Plan"
                    id="Monthly"
                  />
                  <label className="form-check-label" htmlFor="Monthly">
                    Core (Silver) Membership - Monthly Retail
                  </label>
                </div>
                <p>
                  $4.99/month USD
                  <br />
                  <span>(reg. fee: $ 20.00)</span>
                </p>
              </div> */}
                <div className="discount-code d-none">
                  {/* <div>
                  <label htmlFor="Name">Discount Code:</label>{' '}
                  <input type="text" className="form-control input-outline" />
                  <p>
                    If you have been given a Discount Code please enter it
                    above. (EX: TRN1234)
                  </p>
                </div> */}
                  <div className="proceed d-none">
                    <button className="theme-button" type="submit">
                      Proceed
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default JoinNow;
